import React, { useEffect } from 'react';
import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// "Por ahora" la landing de RTC/RTVplus+ usa el render externo de Canva de
// Argentina. Cuando Chile tenga su propia URL (o quiera usar la landing
// interna), reemplazar esta constante o volver a rutear a RTVPlusLanding.
const EXTERNAL_LANDING_URL = 'https://landing.renuevatucloset.com/plus';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh'
  }
});

const RTVPlusLandingRedirect = () => {
  const classes = useStyles();

  useEffect(() => {
    window.location.replace(EXTERNAL_LANDING_URL);
  }, []);

  return (
    <div className={classes.root}>
      <CircularProgress size={60} />
    </div>
  );
};

export default RTVPlusLandingRedirect;
